<template>
  <span :class="rootStyles">
    <img v-if="src" :class="$style.Image" :src="src" />
    <span v-else class="cl-ffffff">{{ $utils.string.getFirstChar(name) }}</span>
  </span>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-facing-decorator'

type AvatarSize = 'extra-tiny' | 'tiny' | 'small' | 'medium' | 'large'

@Component({})
export default class BaseAvatar extends Vue {
  @Prop({ default: 'medium' }) size: AvatarSize
  @Prop() src?: string
  @Prop({ required: true }) name: string

  get rootStyles(): any {
    const styles: any[] = [
      this.$style.BaseAvatar,
      this.$style[`BaseAvatar__${this.size}`]
    ]
    if (this.src) {
      styles.push(this.$style.BaseAvatar__noImage)
    }
    return styles
  }
}
</script>

<style lang="scss" module>
.BaseAvatar {
  width: 22px;
  height: 22px;
  font-size: 10px;
  font-weight: 700;
  border-radius: 100%;
  overflow: hidden;
  background-color: $cl-beced6;
  display: flex;
  justify-content: center;
  align-items: center;

  &__extra-tiny {
    width: 12px;
    height: 12px;
    font-size: 8px;
  }

  &__tiny {
    width: 16px;
    height: 16px;
  }
  &__small {
    width: 24px;
    height: 24px;
  }
  &__large {
    width: 36px;
    height: 36px;
    font-size: 16px;
  }
  &__noImage {
    background-color: $cl-f8f8f8;
  }
}
.Image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
</style>
